<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
      >
        <v-tab @click.prevent="fetchCamerasModeradas">
          Câmeras em exibição
          <span class="tab-count" :class="{ 'tab-count--hidden': !(camerasEmExibicao && camerasEmExibicao.totalItems > 0) }">
            {{ camerasEmExibicao && camerasEmExibicao.totalItems > 0 ? camerasEmExibicao.totalItems : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid>
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button class="colab-toolbar-btn colab-toolbar-btn--remove" aria-label="Remover todas as câmeras em exibição" v-bind="attrs" v-on="on" @click="showConfirmRemoveAll = true">
                <v-icon size="18">mdi-arrow-left</v-icon>
              </button>
            </template>
            <span>Remover todas as câmeras em exibição</span>
          </v-tooltip>
        </div>

        <ModalConfirmAction
          :visible="showConfirmRemoveAll"
          title="Remover câmeras"
          message="Tem certeza que deseja remover todas as câmeras em exibição?"
          confirmText="Remover"
          :loading="removingAll"
          @confirm="removerTodasCamerasModeradas"
          @cancel="showConfirmRemoveAll = false"
        />
        <div
          @dragover.prevent="handleDragOver"
          @dragenter.prevent="handleDragOver"
          @dragleave="handleDragLeave"
          @drop="handleDrop($event)"
          class="drop-zone"
          :class="{ 'drop-zone--active': isDragOver }"
        >
          <template v-if="camerasEmExibicao">
            <template>
              <div
                v-for="camera in camerasEmExibicao.items"
                :key="camera.id_camera"
                class="card-item-wrapper"
                :class="{ 'drop-enter': lastDroppedId === camera.id_camera }"
              >
                <CardCameraEmExibicao
                  :item="camera"
                  :is-selected-to-tarja="
                    selectedToTarja ? selectedToTarja === camera.id_camera : false
                  "
                  @change="updateSelectedToTarja"
                ></CardCameraEmExibicao>
              </div>
            </template>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardCameraEmExibicao from "../Cards/Cameras/CardCameraEmExibicao.vue";
import ModalConfirmAction from "../Modal/ModalConfirmAction.vue";
import { dropTargetMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dropTargetMixin],
  components: { CardCameraEmExibicao, ModalConfirmAction },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      media_type: null,
      midia_url_aprovadas: null,
      loading: false,
      filtro_texto: "",
      selectedToTarja: null,
      showConfirmRemoveAll: false,
      removingAll: false,
    };
  },
  props: {
    camerasEmExibicao: Object,
    moderadasCurrentPage: Number,
  },
  beforeMount() {
    this.filtro_texto =
      localStorage.getItem("@socialcam/filtro_texto_cameras_moderadas") || "";
  },
  computed: {
    ...mapGetters({}),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  watch: {
    camerasEmExibicao: {
      handler(newValue) {
        if (newValue?.items) {
          const itemOnTarja = newValue.items.find((item) => item.is_showing_on_tarja);
          this.selectedToTarja = itemOnTarja?.id_camera || null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      getCameras: "cameras/getCameras",
      getCamerasModeradas: "cameras/getCamerasModeradas",
      setFiltroCamerasModeradas: "cameras/setFiltroCamerasModeradas",
    }),
    updateSelectedToTarja(id_camera, is_selected) {
      this.selectedToTarja = is_selected ? id_camera : null;
    },
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async fetchCamerasModeradas() {
      try {
        this.getCamerasModeradas({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.moderadasCurrentPage,
          size: 5,
          filtro_texto: this.filtro_texto,
        });
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível buscar as câmeras moderadas");
      }
    },
    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_cameras_moderadas", e);
      this.setFiltroCamerasModeradas(e);
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.getCamerasModeradas({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.moderadasCurrentPage,
          size: 5,
          filtro_texto: this.filtro_texto,
        });
      }, 1500);
    },
    async removerTodasCamerasModeradas() {
      try {
        this.removingAll = true;
        const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
        const cameras = this.camerasEmExibicao?.items || [];

        for (const camera of cameras) {
          await apiClient.delete(`/cameras/removerCameraModerada/${camera.id_camera || camera.id}/${cod_producao}`);
          const { data } = await apiClient.get(`/cameras/checkIfPodExists/${camera.id_camera || camera.id}`);
          if (data.pod) {
            await apiClient.post(`/cameras/${camera.id_camera || camera.id}/stop`);
          }
        }

        await this.getCamerasModeradas({
          cod_producao,
          page: 1,
          size: 5,
          filtro_texto: this.filtro_texto,
        });
        await this.getCameras({
          cod_praca: this.$store.state.cameras.selectedPraca?.cod_praca,
          cod_producao,
          filtro_texto: this.$store.state.cameras.filtroCameras,
          flg_favorita: this.$store.state.cameras.flg_favorita,
          page: 1,
          size: 5,
        });

        this.selectedToTarja = null;
        this.$toast.success("Todas as câmeras foram removidas");
      } catch (error) {
        this.$toast.error("Erro ao remover câmeras");
      } finally {
        this.removingAll = false;
        this.showConfirmRemoveAll = false;
      }
    },
    async onDropAction(item, selectedProducao) {
      const formData = {
        id_camera: item.id,
        cod_producao: selectedProducao.cod_producao,
        dsc_login_moderacao: this.$store.state.users.user.dsc_login_usuario,
      };
      await apiClient.post(`/cameras/moderarCamera`, {
        ...formData,
      });
      await this.getCamerasModeradas({
        cod_producao: selectedProducao.cod_producao,
        page: this.moderadasCurrentPage,
        size: 5,
        filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
      });
      const { data } = await apiClient.get(
        `/cameras/checkIfPodExists/${formData.id_camera}`
      );
      if (!data.pod) {
        await apiClient.post(`/cameras/${item.id}/stream`);
      }
      await this.getCameras({
        cod_praca: this.$store.state.cameras.selectedPraca.cod_praca,
        cod_producao: selectedProducao.cod_producao,
        filtro_texto: this.$store.state.cameras.filtroCameras,
        flg_favorita: this.$store.state.cameras.flg_favorita,
        page: this.$store.state.cameras.camerasProducao.currentPage,
        size: 5,
      });
      this.$toast.success("Câmera moderada com sucesso");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
